import {Injectable} from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';
import {
  HHGRateQueryRequest,
  HHGRateQueryResult
} from 'src/app/shared/common-components/common-structure';
import {Observable, of, BehaviorSubject} from 'rxjs';
import {catchError, tap, switchMap, startWith} from 'rxjs/operators';
import {LoadingService} from '../loading/loading.service';

@Injectable({
  providedIn: 'root'
})
export class HhgRateQueryService extends DataService {

  private baseURI = this.apiUri + '/controlKeysByControlType/';
  loader: any;

  public hhgRateQueryRequest = new BehaviorSubject(null);
  public hhgRateQueryFormState = new BehaviorSubject<any>(null);
  /*
   Observable will be emitted after hhgRateQueryRequest has next value and
   call api for saving hhgRateQueryRequest. This will be unsubscribe automatically with aysnc
  */
  hhgRateQueryResults$ = this.hhgRateQueryRequest.pipe(
    tap(t => this.loader.show()),
    switchMap((request) => {
      return this.http.post<HHGRateQueryResult[]>(this.apiUri + '/ratesquerydetails/queryhhg', request)
        .pipe(tap(t => {
          this.loader.hide();
        }),
          catchError(e => {
            this.loader.hide();
            return of([] as HHGRateQueryResult[]);
          }));
    }),
    startWith([] as HHGRateQueryResult[])
  );

  constructor(http: HttpClient, private tmssloader: LoadingService) {
    super(http);
    this.loader = tmssloader;
    this.setUri(this.baseURI);
  }

  /*
   Function to get the Control Keys for Effective date by Control_Type='HHG Rate Effective Dates' And
    with last CONTROL_ID
  */
  getControlKeysByControlTypeForEffectiveDate(): Observable<any> {
    const controlKeysExpURL = this.baseURI + 'hhgRateEffective';
    this.setUri(controlKeysExpURL);
    return this.get();
  }

  /*
  Function to get the Control Keys for Expiry date by Control_Type='HHG Rate Effective Dates' And
   with latest CONTROL_ID

 */
  getControlKeysByControlTypeForExpiryDate(): Observable<any> {
    const controlKeysExpURL = this.baseURI + 'hhgRateExpiry';
    this.setUri(controlKeysExpURL);
    return this.get();
  }


  getControlKeysEffectiveExpiryDate(pickUpDate): Observable<any> {
    /*http://localhost:8380/tmssserver/api/ratesquerydetails/queryControlType/2019-08-10 00:00:00.000*/
    const controlKeysEffectiveExpURL = this.apiUri + '/ratesquerydetails/queryControlType/' + pickUpDate;
    this.setUri(controlKeysEffectiveExpURL);
    return this.get();
  }

  /*
    To update book shipment details for selected hhg rate query
   */
  saveBookShipmentDetailsForHHGRateQuery(hhgRateSelectedItem: any): Observable<string> {
    return this.http.post<string>(this.apiUri + '/shipmentsinfo/saveBookshipments',
      hhgRateSelectedItem);
  }

  /*
    To update book shipment details for selected hhg rate query
   */
  saveBookShipmentDetailsForOTOBookshipments(hhgRateSelectedItem: any): Observable<string> {
    return this.http.post<string>(this.apiUri + '/shipmentsinfo/saveOTOBookshipments',
      hhgRateSelectedItem);
  }

  /*
    Emits observable for each submit query event
  */
  updateHHGRateQueryRequest(hhgRateQueryRequest: HHGRateQueryRequest) {
    this.hhgRateQueryRequest.next(hhgRateQueryRequest);
  }

  /*This API call will download the HHG Rates for the query. */
  downloadHHGRateResult(hhgRateQueryRequest)  {
    return this.http.post<any>(this.apiUri + '/ratesquerydetails/downloadhhgrateresult', hhgRateQueryRequest);
  }
}
